import React from 'react';

import IMG_FAST_FUNDING from '../../../../assets/images/fast_funding.svg';
import IMG_LOW_MONTHLY from '../../../../assets/images/low_monthly_payment.svg';
import IMG_PRIVATE_SECURE from '../../../../assets/images/high_customer_ratings.svg';

const RightSidebar = () => (
  <div className="pt-4 text-base font-bold text-center text-[#000A2F]">
    <div className="flex-col">
      <img src={IMG_FAST_FUNDING} alt="" className="m-auto" />
      <span>Fast Funding</span>
    </div>
    <div className="flex-col">
      <img src={IMG_LOW_MONTHLY} alt="" className="m-auto" />
      <span>Low Monthly Payments</span>
    </div>
    <div className="flex-col">
      <img src={IMG_PRIVATE_SECURE} alt="" className="m-auto" />
      <span>High Customer Ratings</span>
    </div>
  </div>
);

export default RightSidebar;
